import React from 'react'
import { Route, Switch } from "react-router-dom";


// componentes
import Cuenta from '../../components/Customer/Cuenta/Cuenta'

/**
 * @export
 * @function PublicRoutes
 * @extends {Component}
 */
function RouterMisPedidos(props) {

    return (
        <Switch>
            <Route exact path="/customer/cuenta" render={() => <Cuenta {...props} />} />
        </Switch>
    )
}

export default RouterMisPedidos;
